"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimDispenserControlEvseCommandsSerialization = void 0;
class SimDispenserControlEvseCommandsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.SimDispenserControlEvseCommandsSerialization = SimDispenserControlEvseCommandsSerialization;
